import React, { useEffect } from 'react';
import './normativos.css';
import { normativos } from '../../json/normativos';

const Normativos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Documentos Normativos</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/Dn01'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight:'normal' }}
              className='span'
            >
              Estructura Orgánica de la Secretaría de Bienestar e Inclusión Social
            </a>
          </div>
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/Dn02'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight:'normal' }}
              className='span'
            >
              Reglamento Interior de la Secretaría de Bienestar e Inclusión Social 2023
            </a>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/Dn04'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Manual de Organización de la Secretaría de Bienestar e Inclusión Social, Hidalgo 2024
            </a>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/Dn07'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Politicas de Calidad de la SEDESO y sus Servidores Públicos
            </a>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/Dn09'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Valores de los Servidores Públicos
            </a>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/Dn10'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Principios de los Servidores Públicos
            </a>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <a
              href='/Dn11'
              target='_blank'
              rel='noopener noreferrer'
              style={{ fontWeight: 'normal' }}
              className='span'
            >
              Politicas de Control Interno de los Servidores Públicos de la SEDESO
            </a>
          </div>
        </div>
      </div>        

    </div> 
  );
};

export default Normativos;
